<script setup>
</script>
<template>
  <div class="page-container holiday-page share-market-holiday">
    <div class="holiday-banner-section">
      <!-- banner-start -->
      <section class="holiday-banner container_fld">
        <section class="breadcrumbs-sec">
          <div class="container breadcrumbs-ol block">
            <div class="stocks-indices-breadcrumbs_wrap">
              <ol class="stocks-indices-breadcrumbs">
                <li>
                  <a href="/">
                    <span>Home </span>
                  </a>
                </li>
                <!-- <li>
                  <a href="/invest-in-share-market/">
                    <span>Invest </span>
                  </a>
                </li> -->
                <li>
                  <span>Stock Market Holidays 2025 </span>
                </li>
              </ol>
            </div>
          </div>
        </section>

        <div class="container coantainer_sec block">
          <div class="row">
            <div class="col-md-7 col-sm-7 pddg_col">
              <div class="banner_txt">
                <div
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-duration="2000"
                  data-aos-offset="0"
                >
                  <div class="banner-text">
                    <h1 class="header">Share Market Holidays 2025</h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5 pddg_col col-sm-5 desktop-content"></div>
          </div>
        </div>
      </section>
      <!-- banner-End -->
    </div>

    <section class="main-share-market-section">
      <div class="share-market-inner-section">
        <div class="main-heading">
          <p>
            Every year, the National Stock Exchange (NSE) and the BSE, declare a
            list of share market holidays.
          </p>
          <p>
            The share market holiday list gives clarity to investors and traders
            to figure out their moves and strategies. Indian share market
            holidays are typically a mix of regional, national and religious
            holidays.<br />
            The NSE share market holiday list for 2025 includes festive and
            national days such as Maha Shivaratri, Gandhi Jayanti, Republic Day,
            Independence Day, Ganesh Chaturthi and Dussehra. On these stock
            market holidays in 2025, exchanges will remain closed.<br />
            Notably, stock exchanges will remain open for trading on the New
            Year Day, January 1, 2025.
          </p>
          <h2>Share Market Holiday List For 2025</h2>
          <p>
            Check the full list of market holidays for seamless trading in 2025.
          </p>
        </div>
        <div class="holidays-tabs" id="sticky-tab">
          <a
            href="/stocks-market/share-market-holidays/"
            class="tabs-items bg-transparent rounded-none active"
            >Trading Holidays</a
          >
          <a href="/stocks-market/nse-holidays/" class="tabs-items bg-transparent rounded-none"
            >NSE Holidays</a
          >
          <a href="/stocks-market/bse-holidays/" class="tabs-items bg-transparent rounded-none"
            >BSE Holidays</a
          >
          <a href="/stocks-market/mcx-holidays/" class="tabs-items bg-transparent rounded-none"
            >MCX Holidays</a
          >
        </div>

        <section class="holidays">
          <div class="container home-container block">
            <div class="a-article-wrapper holidays-wrapper">
              <h2>
                <strong>Holidays falling on weekdays and weekends</strong>
              </h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Stock Market Holiday List</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Eid-ul-Fitr (Ramzan Eid)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 1, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Bakri Eid</td>
                      <td>June 7, 2025</td>
                      <td>Saturday</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 2, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 5, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <strong>2025 Trading Holiday Circular: </strong
                ><a
                  href="https://nsearchives.nseindia.com/content/circulars/CMTR65587.pdf"
                  target="_blank"
                  >NSE</a
                >,
                <a
                  href="https://www.bseindia.com/static/markets/marketinfo/listholi.aspx#!#24CD"
                  >BSE</a
                >,
                <a
                  href="https://www.mcxindia.com/docs/default-source/circulars/english/2024/december/circular-814-2024.pdf?sfvrsn=80f3539e_2"
                  target="_blank"
                  >MCX</a
                >
              </p>
              <p>
                <b
                  >The only exception in the list of stock market holidays is
                  Diwali, where the BSE and NSE open for a one-hour in the
                  evening for Muhurat trading, which is considered auspicious.
                  Muhurat trading on Diwali is a part of the stock exchange
                  traditions to mark the beginning of New Year or Samvat. The
                  stock exchanges separately notify the Muhurat trading
                  schedule.
                </b>
              </p>
              <p><b>Market Holidays Falling on Weekdays in 2025</b></p>
              <p>
                Here is the list of share market holidays that are falling on
                the weekdays in 2025.
              </p>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Stock Market Holidays on Weekdays</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Eid-ul-Fitr (Ramzan ID)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 1, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 2, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 5, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2><b>Holidays Falling on Weekends in 2025</b></h2>
              <p>
                There are four stock market holidays that fall on the weekends,
                which are Saturday and Sunday, when the BSE and NSE are closed
                anyway. Here is the list of stock market holidays falling on
                weekends.
              </p>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Holiday</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Bakra Eid</td>
                      <td>June 7, 2025</td>
                      <td>Saturday</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <b
                  >Share Market Holidays in 2025: How will it affect trading?</b
                >
              </p>
              <p>
                When the stock markets close for a scheduled holiday, it may
                affect traders and investors in the upcoming trading sessions.
                Stock market holidays are likely to have an impact on prices and
                market movements. Investors and traders adjust their positions
                based on the events being observed to prepare for the next
                trading day. This can lead to fluctuations in the market, with
                the BSE and NSE often witnessing increased volumes before the
                market closes pre-holiday. During festive holidays markets also
                see hectic activities.
              </p>
            </div>
          </div>
        </section>

        <!-- faq Section Start -->
        <section id="calculator_help_section"
          class="calculator_help_section section-padding-bottom faq-sec p-90"
        >
          <div class="container block">
            <h2 class="heading bold help_here text-center">
              Frequently Asked Questions
            </h2>
            <div class="smooth-font">
              <div
                class="panel-group"
                id="accordion"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading1">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse1">
                        <span class="expand_icon dashicons-plus"></span>
                        <span
                          >What are the major share market holidays in India in
                          2025?</span
                        >
                      </span>
                    </h3>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">
                        Share market (NSE and BSE) will be closed on following
                        days in 2025 in addition to weekends. Following list
                        does not contain trading holidays that lie on weekends.
                      </p>
                      <ul class="visible">
                        <li>Maha Shivratri: February 26, 2025 (Wednesday)</li>
                        <li>Holi: March 14, 2025 (Friday)</li>
                        <li>
                          Eid-ul-Fitr (Ramzan Eid): March 31, 2025 (Monday)
                        </li>
                        <li>Mahavir Jayanti: April 10, 2025 (Thursday)</li>
                        <li>
                          Dr. Baba Saheb Ambedkar Jayanti: April 14, 2025
                          (Monday)
                        </li>
                        <li>Good Friday: April 18, 2025 (Friday)</li>
                        <li>Maharashtra Day: May 1, 2025 (Thursday)</li>
                        <li>Independence Day: August 15, 2025 (Friday)</li>
                        <li>Ganesh Chaturthi: August 27, 2025 (Wednesday)</li>
                        <li>
                          Dussehra (Vijaya Dashami) / Mahatma Gandhi Jayanti:
                          October 2, 2025 (Thursday)
                        </li>
                        <li>Diwali-Laxmi Pujan: October 21, 2025 (Tuesday)</li>
                        <li>
                          Diwali-Balipratipada: October 22, 2025 (Wednesday)
                        </li>
                        <li>
                          Guru Nanak Jayanti: November 5, 2025 (Wednesday)
                        </li>
                        <li>Christmas: December 25, 2025 (Thursday)</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading2">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse2">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>Does the stock market close on weekends?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse2" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">
                        Yes, stock markets including NSE and BSE remain closed
                        on weekends unless specified otherwise.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading3">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse3">
                        <span class="expand_icon dashicons-plus"></span>
                        <span
                          >How can I stay updated with share market holidays in
                          2025?</span
                        >
                      </span>
                    </h3>
                  </div>
                  <div id="collapse3" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">
                        You can check the Upstox list above to stay updated
                        about the share market holidays in 2025. Additionally,
                        you can check on the websites of BSE and NSE to see the
                        holidays.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading4">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse4">
                        <span class="expand_icon dashicons-plus"></span>
                        <span
                          >Are all holidays observed by the NSE and BSE?</span
                        >
                      </span>
                    </h3>
                  </div>
                  <div id="collapse4" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">
                        Yes, generally BSE and NSE observe the same holidays
                        every year. However, it is advisable to check their
                        official holiday lists to avoid confusion.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading5">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse5">
                        <span class="expand_icon dashicons-plus"></span>
                        <span
                          >What happens if I place an order on a holiday?</span
                        >
                      </span>
                    </h3>
                  </div>
                  <div id="collapse5" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">
                        If you place an order on a share market holiday, it will
                        be initiated on the next business day when the markets
                        are open. However, there may be a potential impact on
                        market activities the day after a stock market holiday.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- End faq Section Start -->
      </div>

      <div class="login-widget smartlist-login">
        <div class="open-account">
          <p class="stock-form-heading">
            <span>Open a FREE*</span> Demat + Trading account and enjoy
          </p>
          <p class="form-second-paragraph">
            Zero commission* on Mutual Funds and IPO
          </p>
          <p>₹20* per order on Equity, F&amp;O, Commodity and Currency</p>
          <div class="contact-form">
            <form
              class="contact-input-wrap"
              method="post"
              onsubmit="return proceedWithLazyLogin(event, this)"
            >
              <input
                type="tel"
                onkeypress="return isNumber(event)"
                name="phone"
                id="txtcontact"
                maxlength="10"
                placeholder="10-Digit mobile number"
              />
              <div class="error-message" id="error-message"></div>
              <button type="submit" class="submit-btn">Start Investing</button>
            </form>
          </div>
          <hr color="#E1E1E1" />
          <div class="existing-account">
            By signing up you agree to our
            <a href="/terms-of-use-and-privacy-policy/"
              >Terms and Conditions</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss" src="@/styles/css/stock-market-holiday.scss">
</style>
<style lang="scss" src="@/styles/css/seo-calculators.scss">
</style>
<style scoped lang="scss">
  .login-widget.smartlist-login .open-account {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 12px;
    top: 16px;
    width: 100%;
    padding: 24px 24px 16px;
    position: sticky;
  }
  .login-widget.smartlist-login .open-account .header {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.03em;
    color: #5a298b;
  }
  .login-widget.smartlist-login .open-account p {
    font-size: 12px;
    line-height: 16px;
    color: #6a6a6a;
    padding-top: 8px;
  }
  .login-widget.smartlist-login .open-account .contact-form h6 {
    color: #262626;
    font-size: 14px;
    line-height: 20px;
    padding-top: 16px;
    padding-bottom: 8px;
  }
  .smartlist-login .contact-form input {
    width: 100%;
    border-radius: 8px;
    background: #f2f2f2;
    line-height: 24px;
    padding: 8px 8px 8px 36px;
    font-size: 14px !important;
    border: 1px solid transparent;
  }

  .smartlist-login input:focus-visible {
    border-color: #7a26ce !important;
    outline: none;
  }

  .smartlist-login input::-webkit-input-placeholder {
    /* Edge */
    color: #aeaeae;
  }

  .smartlist-login input:-ms-input-placeholder {
    /* Internet Explorer */
    color: #aeaeae;
  }

  .smartlist-login input::placeholder {
    color: #aeaeae;
  }
  .smartlist-login .contact-input-wrap {
    position: relative;
  }
  .smartlist-login .contact-input-wrap::after {
    content: "+91";
    position: absolute;
    color: #6a6a6a;
    top: 9px;
    font-size: 14px;
    line-height: 24px;
    left: 8px;
    font-family: Messina Sans;
  }
  .smartlist-login .error-message span {
    margin-top: 8px;
    display: inline-block;
    font-size: 12px;
    color: #db542a;
  }
  .smartlist-login .error-message span:empty {
    display: none;
  }
  .smartlist-login .submit-btn {
    width: 100%;
    height: 48px;
    background: #5a298b !important;
    border: 1px solid transparent !important;
    border-radius: 24px !important;
    padding: 10px 25px !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 24px !important;
    margin-top: 16px !important;
    transition: all 0.3s ease-in-out 0.1s;
    cursor: pointer;
  }

  .smartlist-login .open-account hr {
    margin: 24px -24px 16px -24px;
    border-color: #e1e1e1;
  }

  .smartlist-login .existing-account {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .smartlist-login .existing-account p {
    padding: 0px !important;
    font-size: 12px;
    line-height: 16px;
    font-family: Messina Sans;
    color: #262626;
  }

  .smartlist-login .login-btn {
    border: 1px solid #d0d0d0 !important;
    border-radius: 100px;
    padding: 8px 16px !important;
    background: white;
    cursor: pointer;
    height: auto !important;
  }

  .smartlist-login .login-btn span {
    font-family: Messina Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #262626;
  }

  .smartlist-login .login-btn:hover span {
    color: #5a298b;
  }

  .smartlist-login .contact-input-wrap:after {
    top: 9px !important;
  }

  @media screen and (max-width: 768px) {
    .login-widget .open-account {
      width: 100%;
      margin-top: 32px;
      position: static;
    }

    .smartlist-login .open-account hr {
      display: none;
    }

    .smartlist-login .existing-account {
      display: none;
    }
  }
</style>
